import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponent } from '@ird/ng-base';
import { TranslateModule } from '@ngx-translate/core';
import { distinctUntilChanged } from 'rxjs';
import { EntraIdAuthService } from '../services/entra-id-auth.service';

@Component({
  selector: 'entra-id-auth-single-sign-on-button',
  templateUrl: './single-sign-on-button.component.html',
  imports: [TranslateModule, ButtonComponent],
})
export class SingleSignOnButtonComponent implements OnInit {
  @Input() redirectUrl?: string;
  @Input() disabled = false;
  @Output() loginAttempt = new EventEmitter<boolean>();
  @Output() loginProgress = new EventEmitter<boolean>();
  @Output() loginClicked = new EventEmitter<boolean>();

  constructor(private readonly entraIdAuthService: EntraIdAuthService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.entraIdAuthService
        .loginAttempt()
        .pipe(distinctUntilChanged())
        .subscribe((loginAttempt) => {
          this.loginAttempt.next(loginAttempt);
        });
    });

    this.entraIdAuthService
      .loginProgress()
      .pipe(distinctUntilChanged())
      .subscribe((loginInProgress) => {
        this.loginProgress.next(loginInProgress);
      });
  }

  login(): void {
    this.loginClicked.emit(true);
    this.entraIdAuthService.login();
  }

  logout(): void {
    this.entraIdAuthService.logout();
  }
}
